// Lightweight lunar-phase math, computed in the VIEWER's local time.
// Based on the mean synodic month from a known reference new moon (2000-01-06 18:14 UTC).
const SYNODIC = 29.530588853; // days
const REF_NEW_MOON_MS = Date.UTC(2000, 0, 6, 18, 14, 0);

const PHASE_NAMES = [
  "New Moon", "Waxing Crescent", "First Quarter", "Waxing Gibbous",
  "Full Moon", "Waning Gibbous", "Last Quarter", "Waning Crescent",
];

export function moonInfo(date = new Date()) {
  const days = (date.getTime() - REF_NEW_MOON_MS) / 86400000;
  let age = days % SYNODIC;
  if (age < 0) age += SYNODIC;
  const frac = age / SYNODIC; // 0=new, 0.5=full
  const illumination = Math.round(((1 - Math.cos(2 * Math.PI * frac)) / 2) * 100);
  const idx = Math.floor(frac * 8 + 0.5) % 8; // nearest of the 8 named phases
  // days until the next full moon (age 14.765…)
  let daysToFull = SYNODIC / 2 - age;
  if (daysToFull < 0) daysToFull += SYNODIC;
  return { phase: PHASE_NAMES[idx], illumination, daysToFull: Math.round(daysToFull), frac, age };
}

// SVG path for the LIT portion of the moon within a circle of radius r centred at (r, r).
export function litPath(frac, r) {
  const cx = r, cy = r;
  const b = Math.cos(2 * Math.PI * frac);       // +1 new … -1 full
  const rx = Math.abs(b) * r;                   // terminator ellipse radius
  const waxing = frac < 0.5;
  const s1 = waxing ? 1 : 0;                    // outer lit limb: right when waxing
  let s2;
  if (b > 0) s2 = waxing ? 0 : 1;               // crescent
  else s2 = waxing ? 1 : 0;                      // gibbous
  return `M${cx},${cy - r} A${r},${r} 0 0 ${s1} ${cx},${cy + r} A${rx},${r} 0 0 ${s2} ${cx},${cy - r} Z`;
}
